'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { Box } from '../box/box.component.js';
import { Link } from '../link/link.component.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { FlexBox } from '../flex-box/flex-box.component.js';

let o = {
    ratingValue: e$1.number.isRequired,
    hideRating: e$1.bool,
    reviews: e$1.number,
    href: e$1.string,
    skin: e$1.oneOf([
        'standard',
        'monochromatic'
    ])
};
const RatingsStars = createComponent({
    displayName: 'RatingsStars',
    root: 'div',
    propTypes: o,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.ratingsStars,
    propConfig: {
        classNames (a) {
            let e = new Set([
                'swan-ratings'
            ]);
            return a.skin && 'standard' !== a.skin && e.add(`swan-ratings-skin-${a.skin}`), e;
        },
        wrapChildren ({ ratingValue: a, reviews: t, href: n, hideRating: o = !1, 'aria-label': m }) {
            let [l, p] = a.toFixed(1).split('.').map((a)=>Number(a));
            return e.createElement(FlexBox, {
                className: "swan-ratings-stars-container",
                alignItems: 'center',
                gap: 2
            }, e.createElement(Box, {
                className: "swan-ratings-stars",
                role: "img",
                "aria-label": m
            }, Array.from({
                length: 5
            }).map((a, r)=>{
                let t = [
                    'swan-ratings-star'
                ];
                return r + 1 <= l && t.push('swan-ratings-star-filled'), (p && r + 1) === l + 1 && t.push(`swan-ratings-star-filled-p${p}`), e.createElement("span", {
                    key: `star_${r}`,
                    className: t.join(' ')
                });
            })), !o && e.createElement("span", {
                className: "swan-ratings-stars-rating"
            }, a), null != t && e.createElement("span", {
                className: "swan-ratings-stars-reviews"
            }, "(", n ? e.createElement(Link, {
                to: n
            }, t) : t, ")"));
        }
    }
});

export { RatingsStars };
